module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.6.0-123.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.6.0.md
// module id = 540
// module chunks = 265